import { render, staticRenderFns } from "./dangerItemPop.vue?vue&type=template&id=084153b0"
import script from "./dangerItemPop.vue?vue&type=script&lang=js"
export * from "./dangerItemPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084153b0')) {
      api.createRecord('084153b0', component.options)
    } else {
      api.reload('084153b0', component.options)
    }
    module.hot.accept("./dangerItemPop.vue?vue&type=template&id=084153b0", function () {
      api.rerender('084153b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/base/dangerItemPop.vue"
export default component.exports